var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpice1Steady(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint0_linear)",
    d: "M7.88 9.76h8.25c.62 0 1.12-.5 1.12-1.12s-.5-1.12-1.12-1.12H7.88c-.62 0-1.12.5-1.12 1.12s.5 1.12 1.12 1.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint1_linear)",
    d: "M7.88 9.76h8.25c.62 0 1.12-.5 1.12-1.12s-.5-1.12-1.12-1.12H7.88c-.62 0-1.12.5-1.12 1.12s.5 1.12 1.12 1.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint2_radial)",
    d: "M7.88 9.76h8.25c.62 0 1.12-.5 1.12-1.12s-.5-1.12-1.12-1.12H7.88c-.62 0-1.12.5-1.12 1.12s.5 1.12 1.12 1.12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint3_linear)",
    d: "M10.5 5.26h3v15h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint4_radial)",
    d: "M10.5 5.26h3v11.85l-3 3.15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint5_linear)",
    d: "M20.98 16.51h-2.97c-.65 0-1.01-.77-.58-1.26l2.54-2.97c.43-.5 1.24-.26 1.34.39l.43 2.97a.76.76 0 01-.76.87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint6_linear)",
    d: "M20.98 16.51h-2.97c-.65 0-1.01-.77-.58-1.26l2.54-2.97c.43-.5 1.24-.26 1.34.39l.43 2.97a.76.76 0 01-.76.87"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint7_linear)",
    d: "M3.01 16.51h2.97c.65 0 1-.77.58-1.26l-2.54-2.98a.759.759 0 00-1.33.39l-.43 2.98c-.06.42.23.81.65.86h.11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint8_linear)",
    d: "M3.52 16.51c1.23 3.49 4.56 6 8.48 6s7.25-2.51 8.48-6h-2.44a6.755 6.755 0 01-12.1 0H3.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint9_linear)",
    d: "M3.52 16.51c1.23 3.49 4.56 6 8.48 6s7.25-2.51 8.48-6h-2.44a6.755 6.755 0 01-12.1 0H3.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint10_linear)",
    d: "M9.75 3.76C9.75 5 10.76 6.01 12 6.01S14.25 5 14.25 3.76 13.24 1.51 12 1.51 9.75 2.52 9.75 3.76m1.5 0c0-.41.34-.75.75-.75s.75.34.75.75-.34.75-.75.75-.75-.34-.75-.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-1-steady_svg__spice1-paint11_radial)",
    d: "M9.75 3.76C9.75 5 10.76 6.01 12 6.01S14.25 5 14.25 3.76 13.24 1.51 12 1.51 9.75 2.52 9.75 3.76m1.5 0c0-.41.34-.75.75-.75s.75.34.75.75-.34.75-.75.75-.75-.34-.75-.75"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint0_linear",
    x1: 17.253,
    x2: 8.725,
    y1: 8.633,
    y2: 8.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint1_linear",
    x1: 12.002,
    x2: 12.002,
    y1: 10.095,
    y2: 9.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint3_linear",
    x1: 13.217,
    x2: 10.727,
    y1: 12.757,
    y2: 12.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint5_linear",
    x1: 21.753,
    x2: 17.253,
    y1: 14.258,
    y2: 14.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint6_linear",
    x1: 19.72,
    x2: 19.5,
    y1: 16.98,
    y2: 15.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint7_linear",
    x1: 6.753,
    x2: 2.252,
    y1: 14.25,
    y2: 14.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint8_linear",
    x1: 20.485,
    x2: 4.803,
    y1: 19.507,
    y2: 19.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint9_linear",
    x1: 11.387,
    x2: 11.86,
    y1: 13.882,
    y2: 15.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-1-steady_svg__spice1-paint10_linear",
    x1: 12,
    x2: 12,
    y1: 1.51,
    y2: 6.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-1-steady_svg__spice1-paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-109.84 4.152 .17) scale(2.87 1.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#696969",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-1-steady_svg__spice1-paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.33121 12.82524 -16.3045 4.23491 5 -1.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-1-steady_svg__spice1-paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135.85 -2.735 -1.996) scale(2.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454",
    stopOpacity: 0
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgSpice1Steady as ReactComponent };